import React, {Component} from 'react'
import {connect} from 'react-redux';
import { Form, Input, DatePicker, Checkbox, Button, Select } from 'antd';
import PropTypes from "prop-types";
import moment from 'moment';
import * as APP_CONFIG from "../constants/config";
import {addMalfunction, updateMalfunction, malfunctionsFetchList} from '../actions/malfunctions';
const FormItem = Form.Item;
const { TextArea } = Input;
const {MySQLDateTimeFormat, DateFormat } = APP_CONFIG;
const storingtypen = APP_CONFIG.defaults.storingtypen;

class MalfunctionForm extends Component {
    static propTypes = {
        form: PropTypes.shape({
            validateFieldsAndScroll: PropTypes.func,
            getFieldDecorator: PropTypes.func,
        }),
        params: PropTypes.shape({
            id: PropTypes.string.isRequired
        }),
        malfunctions: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            malfunction: this.getMalfunction(props),
            malfunctionid: props.match.params.id,
        };
    }

    getMalfunction = ({ malfunctions, match }) => {
        let malfunction = null;
        malfunctions.forEach((element) => {
            if(element.id === parseInt(match.params.id,10))
                malfunction = element;
        });
        if(malfunction === null) {
            malfunction = APP_CONFIG.defaults.malfunction;
            console.error(`malfunction not found with ${match.params.id}`);
        }
        return malfunction;
    };

    updateMalfunction = (key, val) => {
        const { malfunction } = this.state;
        malfunction[key] = val;
        this.setState({malfunction : {...malfunction}});
    };

    onChange = (e) => {
        const key = e.target.id;
        const val = e.target.value;
        this.updateMalfunction(key, val);
    };

    onChangeStoringType = (value) => {
        this.updateMalfunction('storingtype', value);
    };

    onChangeStoringSubType = (value) => {
        this.updateMalfunction('storingsubtype', value);
    };

    onChangeCheckbox = (e) => {
        const key = e.target.id;
        console.log(`value van cb: ${e.target.value}`);
        console.log(`checked van cb: ${e.target.checked}`);
        console.log(`key: ${key}`);


        const val = e.target.checked;
        e.target.value = val; // validator kijkt naar val die on is als checked
        this.updateMalfunction(key, e.target.checked);
    };

    onChangeDatepicker = (moment, key) => {
        const val = moment ? moment.format(MySQLDateTimeFormat) : '';
        console.log('onChangeDatepicker', val, moment)
        this.updateMalfunction(key, val);
    };

    addMalfunction = async () => {
        const thisId = this.state.malfunctionid;
        try{
            if (thisId === 0) { // ! kan hier?
                await this.props.dispatch(addMalfunction(this.state.malfunction));
            }
            else {
                await this.props.dispatch(updateMalfunction(this.state.malfunction));
            }
            await this.props.dispatch(malfunctionsFetchList());

            this.props.history.push(`/storingen/${thisId}`);
        }
        catch(err){
            console.error('error addMalfunction ', err);
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                try {
                    this.addMalfunction();
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }

    toOverview = (id) => {
        this.props.history.push(`/storingen/${id}`);
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const item  = this.state.malfunction;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },

            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },

        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 0,
                },
            },
        };
        const klantInputConfig = {
            initialValue: item.klant,
            rules: [ {type: 'string', required: true, message: 'Klant ook doen!',
            }],
            onChange: this.onChange,
        };
        const locatieInputConfig = {
            initialValue: item.locatie,
            rules: [ {type: 'string', required: true, message: 'Locatie ook doen!',
            }],
            onChange: this.onChange,
        };
        const contactpersoonInputConfig = {
            initialValue: item.contactpersoon,
            rules: [ {type: 'string', required: false,
            }],
            onChange: this.onChange,
        };
        const contactgegevensInputConfig = {
            initialValue: item.contactgegevens,
            rules: [ {type: 'string', required: false,
            }],
            onChange: this.onChange,
        };
        const storingstypeInputConfig = {
            initialValue: item.storingtype,

            onChange: this.onChangeStoringType,
        };
        const storingssubtypeInputConfig = {
            initialValue: item.storingsubtype,

            onChange: this.onChangeStoringSubType,
        };
        const datePickerConfig = {
            rules: [{ type: 'object', required: true, message: 'Aanmeldingsdatum ook doen!' }],
            initialValue: moment(item.aanmeldingsdatum.replace('Z','').replace('T',' '), MySQLDateTimeFormat),
        };

        const beschrijvingConfig = {
            rules: [{type: 'string', required: false, }],
            initialValue: item.beschrijving,
            onChange: this.onChange,
        };
        const zichtbaarklantConfig = {
            initialValue: item.zichtbaar_voor_klant,
            //rules: [{type: 'boolean', required:false, disabled: false}],
            onChange: this.onChangeCheckbox,
        }

        /*console.log('aanmeldingsdatum:',item.aanmeldingsdatum);*/

        return (
            <Form onSubmit={this.handleSubmit}>

                <FormItem
                    label="Klant"
                    {...formItemLayout}
                    hasFeedback
                >
                    {getFieldDecorator('klant',

                        klantInputConfig)(

                        <Input disabled={true}/>
                    )}
                </FormItem>
                <FormItem
                    label="Locatie"
                    disabled={true}
                    {...formItemLayout}
                    hasFeedback
                >
                    {getFieldDecorator('locatie',

                        locatieInputConfig)(

                        <Input disabled={true}/>
                    )}
                </FormItem>
                <FormItem
                    label="Contactpersoon"
                    {...formItemLayout}
                >
                    {getFieldDecorator('contactpersoon',

                        contactpersoonInputConfig)(

                        <Input />
                    )}
                </FormItem>
                <FormItem
                    label="Contactgegevens"
                    {...formItemLayout}
                >
                    {getFieldDecorator('contactgegevens',

                        contactgegevensInputConfig)(

                        <Input />
                    )}
                </FormItem>
                <FormItem
                    label="Type storing"
                    {...formItemLayout}
                >
                    {getFieldDecorator('storingtype',

                        storingstypeInputConfig)(

                        <Select>
                            {
                                storingtypen.map((stype,index) => {
                                    return(
                                        <Select.Option key={index} value={stype.type}>{stype.type}</Select.Option>
                                    );
                                })
                            }
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    label="Subtype Storing"
                    {...formItemLayout}
                >
                    {getFieldDecorator('storingsubtype',

                        storingssubtypeInputConfig)(

                        <Select>
                            {
                                storingtypen.filter(stype => stype.type === this.state.malfunction.storingtype).map(stype => {

                                    return stype.subtypes.map((subtype, index) =>
                                        <Select.Option key={index} value={subtype}>{subtype}</Select.Option>
                                    );
                                })
                            }
                        </Select>
                    )}
                </FormItem>

                <FormItem
                    label="Zichtbaar voor de klant"
                    {...formItemLayout}
                >
                    {getFieldDecorator('zichtbaar_voor_klant',

                        zichtbaarklantConfig)(

                        <Checkbox checked={item.zichtbaar_voor_klant}/>
                    )}
                </FormItem>
                <FormItem
                    label="Beschrijving"
                    {...formItemLayout}
                >
                    {getFieldDecorator('beschrijving',

                        beschrijvingConfig)(

                        <TextArea rows={4}/>
                    )}
                </FormItem>
                <FormItem
                    label="Aanmeldingsdatum"
                    {...formItemLayout}
                >
                    {getFieldDecorator('aanmeldingsdatum',

                        datePickerConfig)(

                        <DatePicker
                            //showTime
                            /*initialValue={moment(item.aanmeldingsdatum).format(DateTimeFormat)}*/
                            /*dateRender={(current) => {
                                return moment(current,DateTimeFormat)
                            }}*/
                            //defaultValue={moment(item.aanmeldingsdatum, DateTimeFormat)}
                            //format={MySQLDateTimeFormat}
                            format={DateFormat}
                            style={{
                                width: '100%'
                            }}
                            onChange={(date) => this.onChangeDatepicker(date,'aanmeldingsdatum')}
                        />

                    )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">Opslaan</Button>
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" onClick={()=>this.toOverview(this.state.malfunctionid)}>Overzicht storing</Button>
                </FormItem>
            </Form>
        );
    }
}

const WrappedMalfunctionForm = Form.create()(MalfunctionForm);

let mapStateToProps = ({malfunctions}) => ({
    malfunctions: [...malfunctions.malfunctions]

});

export default connect(mapStateToProps)(WrappedMalfunctionForm);
/*
* - config malfunction default
*   - locatie_id: 0 : geef id
*
*   ? - wat doen met plaatsnaam?
*
* */



// WEBPACK FOOTER //
// ./src/components/MalfunctionForm.js